import * as React from 'react';
import { observer } from 'mobx-react';
import { Parse } from 'helpers/Parse';
import { getImage } from 'helpers/SportImageHelper';
import Table from 'components/Table';
import AvatarCell from 'components/Table/AvatarCell';
import _ from 'lodash';
import SectionTitle from 'components/SectionTitle';
import Moment from 'moment';
import { navigationStore, memberDetailsStore } from 'stores';
import { readableActivity } from 'helpers/ActivitiesHelper';

interface Props {
    userId: string
}

@observer class NoShows extends React.Component<Props> {

    componentDidMount() {
        const { userId } = this.props;
        memberDetailsStore.getNoShowActivities(userId);
    }

    onTableRowClicked = (activity: Parse.Object) => {
        navigationStore.push(`/activitydetails/${activity.id}`);
    }

    render() {
        const noShowActivities = memberDetailsStore.noShowActivities || [];
        if (noShowActivities.length === 0) return null;

        const columns = [
            {
                Header: '',
                id: 'name',
                accessor: (activity: Parse.Object) => {
                    const sportKey = activity.get('sportKey')
                    const imageUrl = getImage(sportKey);
                    const title = activity.get('customTitle');
                    const subTitle = readableActivity(sportKey);

                    return <AvatarCell
                        imageUrl={imageUrl}
                        title={title}
                        subTitle={subTitle}
                    />
                }
            },
            {
                Header: 'Date',
                id: 'gameStart',
                width: 210,
                accessor: (activity: Parse.Object) => {
                    return Moment(activity.get('gameStart'))
                        .local()
                        .format('MM-DD-YYYY hh:mm A');
                },
                sortMethod: (a: any, b: any, desc: any) => {
                    if (Moment(a, "MM-DD-YYYY hh:mm A").isBefore(Moment(b, "MM-DD-YYYY hh:mm A"))) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }
            }
        ]

        return (
            <div>
                <SectionTitle title='No shows' skipMarginBottom={true} />

                <Table
                    onRowClicked={this.onTableRowClicked}
                    data={noShowActivities}
                    columns={columns}
                />
            </div >
        )
    }

}

export default NoShows;